var React = require('react');

function RectoryIdent (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.5056 0C28.5097 10.6264 25.9171 21.0944 20.9511 30.5018C15.9851 39.9091 8.79486 47.9735 0 54C8.89659 49.7593 18.6355 47.558 28.5 47.558C38.3645 47.558 48.1034 49.7593 57 54C48.2065 47.973 41.0179 39.9081 36.0539 30.5007C31.0898 21.0933 28.4993 10.6256 28.5056 0V0ZM28.5056 42.8137C23.6397 42.6476 18.8024 43.6188 14.3818 45.6494C20.6977 41.3066 28.5056 29.1491 28.5056 19.3918C28.5056 29.1491 36.3584 41.2954 42.6294 45.6494C38.2086 43.6196 33.3715 42.6485 28.5056 42.8137Z","fill":"#BEA169"}));
}

RectoryIdent.defaultProps = {"width":"57","height":"54","viewBox":"0 0 57 54","fill":"none"};

module.exports = RectoryIdent;

RectoryIdent.default = RectoryIdent;
